module.exports = __webpack_public_path__ + "static/media/header_icon.3b4721e1.png";